import { css } from "@emotion/react"

export const MemberListWrapperStyle = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const fullContentStyle = css`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`
